import { put, takeEvery } from 'redux-saga/effects';
import {
  fetchprivilegesSuccess,
  fetchprivilegesFailure,
} from 'redux/ums-user-management/actions';
import request from 'utils/request';
import urls from 'utils/config';
import UmsUserManagementActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

export function* fetchPrivileges() {
  const url = `${API_BASE_URL}/ums/privileges`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchprivilegesSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Privileges: ${response.message}`);

    yield put(fetchprivilegesFailure(response.message));
  }
}

export function* onFetchfetchPrivileges() {
  yield takeEvery(
    UmsUserManagementActionTypes.FETCH_UMS_PRIVILEGES_START,
    fetchPrivileges
  );
}
